/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_SettingInputs */

const en_fw_node_setting = /** @type {(inputs: Fw_Node_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting`)
};

const zh_fw_node_setting = /** @type {(inputs: Fw_Node_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`舞台`)
};

/**
* | output |
* | --- |
* | "Setting" |
*
* @param {Fw_Node_SettingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_setting = /** @type {((inputs?: Fw_Node_SettingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_SettingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_setting(inputs)
	return zh_fw_node_setting(inputs)
});
export { fw_node_setting as "fw.node.setting" }